import { motion } from "framer-motion";
import { Chapter, EASE, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const Journey = () => (
  <section
    id="journey"
    data-testid="journey-section"
    className="bg-[#08162B] text-white py-24 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="05" label="The Journey" dark />

      <div className="mt-12 grid lg:grid-cols-2 gap-10 lg:gap-16">
        <div>
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">FROM:</p>
            <p className="mt-3 font-condensed font-light text-3xl sm:text-5xl text-white/90 leading-tight">
              "What should I sell?"
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">TO:</p>
            <p className="mt-3 font-condensed font-light text-3xl sm:text-5xl text-white leading-tight">
              "How do I scale this?"
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-14 max-w-md">
            <p className="text-lg sm:text-xl leading-relaxed text-white/60">
              The Ecom Bible shows you what to focus on <span className="text-white">now</span> —
              and what can wait until later.
            </p>
          </Reveal>
        </div>

        <ol className="relative border-l border-white/15 pl-8 sm:pl-12 space-y-1" data-testid="journey-timeline">
          {config.journey.map((step, i) => (
            <motion.li
              key={step}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-8% 0px" }}
              transition={{ duration: 0.6, ease: EASE }}
              className="relative py-3.5 group"
            >
              <span
                className={`absolute -left-8 sm:-left-12 top-1/2 -translate-y-1/2 -translate-x-1/2 h-2 w-2 rotate-45 transition-colors duration-300 ${
                  i === config.journey.length - 1
                    ? "bg-[#D4AF37]"
                    : "bg-white/30 group-hover:bg-[#D4AF37]"
                }`}
              />
              <div className="flex items-baseline gap-4 sm:gap-6">
                <span className="font-mono text-[10px] sm:text-[11px] text-white/35 tracking-[0.2em] w-7 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span
                  className={`font-sans font-bold uppercase tracking-tight text-lg sm:text-2xl transition-colors duration-300 ${
                    i === config.journey.length - 1
                      ? "text-[#D4AF37]"
                      : "text-white/75 group-hover:text-white"
                  }`}
                >
                  {step}
                </span>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default Journey;
